import { useState, useCallback } from 'react';
import useAlertStore from '@/stores/alertStore';
import { noteGoApiFetch } from '@/services/noteGoApi/noteGoApiFetcher';
import { errorReporter } from '@/services/errorReportingService';

export const useSendToZapier = () => {
  const showAlert = useAlertStore((state) => state.showAlert);
  const [isSending, setIsSending] = useState(false);

  const sendToZapier = useCallback(
    async (noteId: string) => {
      if (!noteId) return;
      setIsSending(true);
      try {
        const response = await noteGoApiFetch({
          url: '/zapier/send',
          method: 'POST',
          body: { note_id: noteId },
        });
        showAlert('Note sent to Zapier successfully!', 'success');
        return response;
      } catch (error) {
        errorReporter.expected('Failed to send note to Zapier', error, {
          feature: 'zapier',
          operation: 'sendToZapier',
          noteId,
        });
        showAlert('Failed to send to Zapier. Check your webhook URL in Beta settings.', 'error');
      } finally {
        setIsSending(false);
      }
    },
    [showAlert],
  );

  return { sendToZapier, isSending };
};
